import callApi from "../../api/axios";

export const getCommission = () => {
  return callApi({
    method: "GET",
    url: `commission-programs`,
  });
};
